import React, { useState, useEffect } from "react";

import EventsList from "./components/services/events-list"
import UpdateEvent from "./components/services/events-update"
import CreateEvent from "./components/services/events-create"


const ProfileView = () => {

  const [updateOrCreate, setUpdateOrCreate] = useState("n");
  const [id, setId] = useState();
  console.log(id)
  console.log(updateOrCreate)


  
  return (
    <>
      {updateOrCreate === "n" && <EventsList setId={(val) => setId(val)} setUpdateOrCreate={(val) => setUpdateOrCreate(val)} />}
      {updateOrCreate === "u" && <UpdateEvent id={id} setId={(val) => setId(val)} setUpdateOrCreate={(val) => setUpdateOrCreate(val)} />}
      {updateOrCreate === "c" && <CreateEvent setId={(val) => setId(val)} setUpdateOrCreate={(val) => setUpdateOrCreate(val)} />}
      
    </>
  );
};

export default ProfileView;
